import React from "react";
import Image from "next/image";
import styles from "./CourseCertificate.module.css";
interface CertificateImageData {
  url: string;
  alternativeText?: string | null;
}

interface CertificateItemData {
  id: number;
  heading?: string;
  sub_heading?: string | null;
  image?: CertificateImageData | null;
}

export interface CourseCertificateData {
  title?: string;
  hide_section?: boolean;
  certificate_image?: CertificateImageData | null;
  items?: CertificateItemData[];
}

interface CourseCertificateProps {
  data?: CourseCertificateData;
}

const CourseCertificate: React.FC<CourseCertificateProps> = ({ data }) => {
  console.log("CourseCertificate data:", data);

  // Hide section if hide_section is true
  if (data?.hide_section === true) {
    return null;
  }

  const certificateImage = data?.certificate_image;
  const items = data?.items || [];
  return (
    <div className={styles.certificateSection}>
      <div className="container">
        {data?.title && (
          <h2 className={styles.sectionTitle}>{data.title}</h2>
        )}

        <div className={styles.certificateContainer}>
          <div className={styles.leftSection}>
            <div className={styles.featureCards}>
              {items.length > 0 ? (
                items.map((card) => (
                  <div key={card.id} className={styles.featureCard}>
                    {card.image?.url && (
                      <div className={styles.cardIcon}>
                        <Image
                          src={card.image.url}
                          alt={
                            card.image.alternativeText ||
                            card.heading ||
                            "Certificate item"
                          }
                          width={32}
                          height={32}
                          className={styles.cardImage}
                        />
                      </div>
                    )}
                    <div className={styles.cardContent}>
                      {card.heading && (
                        <h3 className={styles.cardTitle}>{card.heading}</h3>
                      )}
                      {card.sub_heading && (
                        <p className={styles.cardDescription}>
                          {card.sub_heading}
                        </p>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <p className={styles.emptyState}>
                  Certificate highlights will be available soon.
                </p>
              )}
            </div>
          </div>

          <div className={styles.rightSection}>
            <div className={styles.certificate}>
              <div className={styles.certificateContent}>
                {certificateImage?.url ? (
                  <div className={styles.certificateImageWrapper}>
                    <Image
                      src={certificateImage.url}
                      alt={
                        certificateImage.alternativeText ||
                        data?.title ||
                        "Certificate"
                      }
                      width={800}
                      height={1000}
                      className={styles.certificateImage}
                      priority
                    />
                  </div>
                ) : (
                  <div className={styles.certificatePlaceholder}>
                    <p>Certificate image will be displayed here</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCertificate;

